export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14906.36c00a4d.jpg";